import { ModalFooter } from '@/src/components/Antd';
import { CheckCountry } from '@/src/pages/Settings/Components/SelectCountryArea';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const Modal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { checked, list, onCancel, onConfirm } = props;
  const [data, setData] = React.useState(checked || []);
  React.useEffect(() => {
    if (data !== checked) {
      setData(checked || []);
    }
  }, [checked]);
  return (
    <React.Fragment>
      <div className={css.modalContainer}>
        <CheckCountry
          list={list}
          value={data}
          onChange={(e) => {
            console.log(e);
            setData(e);
          }}
        />
      </div>
      <ModalFooter
        onCancel={onCancel}
        okText={getI18n('general.save')}
        onOk={() => {
          onConfirm(data);
        }}
      />
    </React.Fragment>
  );
};
export default Modal;
